






import { defineComponent, PropType } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "SwitchMicrophone",
  components: { BaseIconButton },
  props: {
    audioConstraints: { type: [Object, Boolean] as PropType<MediaTrackConstraints | boolean> },
  },
  setup(props, { emit }) {
    const onClick = () => {
      emit("changeDevice", { audio: !props.audioConstraints });
    };
    return {
      onClick,
    };
  },
});
